import { Exception, Record } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { class_type, record_type, string_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";

export class Profile extends Record {
    constructor(id, name, email, language) {
        super();
        this.id = id;
        this.name = name;
        this.email = email;
        this.language = language;
    }
}

export function Profile_$reflection() {
    return record_type("Loop54.Portal.WebUI.Services.Auth.AuthUser.Profile", [], Profile, () => [["id", string_type], ["name", string_type], ["email", string_type], ["language", string_type]]);
}

export class User extends Record {
    constructor(profile, accessToken) {
        super();
        this.profile = profile;
        this.accessToken = accessToken;
    }
}

export function User_$reflection() {
    return record_type("Loop54.Portal.WebUI.Services.Auth.AuthUser.User", [], User, () => [["profile", Profile_$reflection()], ["accessToken", string_type]]);
}

export class MissingClaimException extends Exception {
    constructor(message) {
        super(message);
    }
}

export function MissingClaimException_$reflection() {
    return class_type("Loop54.Portal.WebUI.Services.Auth.AuthUser.MissingClaimException", undefined, MissingClaimException, class_type("System.Exception"));
}

export function MissingClaimException_$ctor_Z721C83C5(message) {
    return new MissingClaimException(message);
}

export function createUser(u) {
    if ((u == null) ? true : (u.profile == null)) {
        throw MissingClaimException_$ctor_Z721C83C5("Authentication response did not contain a user profile.");
    }
    const userId = u.profile.user_id;
    const accessToken = u.access_token;
    if (accessToken == null) {
        throw MissingClaimException_$ctor_Z721C83C5("Authentication response is missing an access token.");
    }
    if (userId == null) {
        throw MissingClaimException_$ctor_Z721C83C5("Authentication response is missing the required \'user_id\' claim (check the Keycloak protocol mapper).");
    }
    return new User(new Profile(userId, u.profile.name, u.profile.email, u.profile.locale), accessToken);
}

